export default __webpack_public_path__ + "static/media/Photographs.f5c051bd.png";